import { Link } from "react-router-dom";
import { Phone, Mail } from "lucide-react";

const LOGO_URL = "https://customer-assets.emergentagent.com/job_appointment-updates-1/artifacts/qzbw7g9c_cropped-MMR-Logo-Full-Colour--e1752627254366.webp";

export default function Header() {
  return (
    <header 
      className="sticky top-0 z-50 bg-white/95 backdrop-blur-sm border-b border-slate-100 shadow-sm"
      data-testid="header"
    >
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="flex items-center justify-between h-16 md:h-20">
          {/* Logo */}
          <Link 
            to="/" 
            className="logo-container flex items-center"
            data-testid="header-logo-link"
          >
            <img 
              src={LOGO_URL} 
              alt="Muscle & Movement Rehab" 
              className="h-10 md:h-12 w-auto"
            />
          </Link>

          {/* Contact Info - Hidden on mobile */}
          <div className="hidden md:flex items-center space-x-6">
            <a 
              href="tel:+16474903782" 
              className="flex items-center space-x-2 text-slate-600 hover:text-[#0047AB] transition-colors"
              data-testid="header-phone-link"
            >
              <Phone className="h-4 w-4" />
              <span className="text-sm font-medium">+1 647-490-3782</span>
            </a>
            <a 
              href="mailto:admin@muscleandmovement.com" 
              className="flex items-center space-x-2 text-slate-600 hover:text-[#0047AB] transition-colors"
              data-testid="header-email-link"
            >
              <Mail className="h-4 w-4" />
              <span className="text-sm font-medium">admin@muscleandmovement.com</span>
            </a>
          </div>

          {/* Mobile Contact Button */}
          <a 
            href="tel:+16474903782" 
            className="md:hidden flex items-center justify-center w-10 h-10 rounded-full bg-[#0047AB] text-white"
            data-testid="header-mobile-phone"
          >
            <Phone className="h-5 w-5" />
          </a>
        </div>
      </div>
    </header>
  );
}
